/**
 * @generated SignedSource<<389a0c9cca37a9106eea99b67302cd4d>>
 * @relayHash 1bb9aec93102aca22d4b37b710219970
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1bb9aec93102aca22d4b37b710219970

import { ConcreteRequest } from 'relay-runtime';
export type CriticalityLevel = "CRITICAL" | "INFO" | "WARNING";
export type DisplayFor = "CALL_CENTER_AGENT" | "CUSTOMER_SERVICE_CENTER" | "DOCTOR" | "NONE" | "NURSING_PROFESSIONAL";
export type useShowingNewsSubscription$variables = Record<PropertyKey, never>;
export type useShowingNewsSubscription$data = {
  readonly showingNews: ReadonlyArray<{
    readonly createdAt: string;
    readonly criticalityLevel: CriticalityLevel;
    readonly displayFor: ReadonlyArray<DisplayFor>;
    readonly endTime: string | null;
    readonly englishContent: string;
    readonly frenchContent: string;
    readonly germanContent: string;
    readonly id: string;
    readonly isShowing: boolean;
    readonly italianContent: string;
    readonly startTime: string;
  }>;
};
export type useShowingNewsSubscription = {
  response: useShowingNewsSubscription$data;
  variables: useShowingNewsSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "News",
    "kind": "LinkedField",
    "name": "showingNews",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "criticalityLevel",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "displayFor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "endTime",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "englishContent",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "frenchContent",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "germanContent",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isShowing",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "italianContent",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "startTime",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useShowingNewsSubscription",
    "selections": (v0/*:: as any*/),
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useShowingNewsSubscription",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "id": "1bb9aec93102aca22d4b37b710219970",
    "metadata": {},
    "name": "useShowingNewsSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "c12aa168414116eaa3429f6a5d9e0560";

export default node;
